import React from 'react';
import {__, solea_searchtable} from '../../../../assets/javascripts/library.js';

function SearchableSearchField({searchable_table_id}) {
    return (
        <p class="solea_table_search_field">
            <input type="text" id="searchInput"
                   onKeyUp={ (e) => solea_searchtable(searchable_table_id, e.target) }
                   placeholder={__( 'Filter participant', 'solea' ) } />
        </p>
    );
}

export default SearchableSearchField;


